export class SyncData {
  id: string;
  lastSyncAt?: string;
  bioforestEnvironmentName?: string;
  bioforestUrl?: string;

  constructor(data?: Partial<SyncData>) {
    this.id = data?.id ?? 'sync-data';
    this.lastSyncAt = data?.lastSyncAt;
    this.bioforestEnvironmentName = data?.bioforestEnvironmentName;
    this.bioforestUrl = data?.bioforestUrl;
  }
}
